import React from 'react';
import { Button } from './ui/Button';
import { Tag, Clock } from 'lucide-react';
import { trackEvent } from '../utils/metaPixel';
export function CTASection() {
  const handleBuyClick = () => {
    trackEvent('AddToCart', {
      content_name: 'Calentadores Aura Polar',
      content_ids: ['aura-polar'],
      content_type: 'product',
      value: 31.95,
      currency: 'USD'
    });
    window.open('https://www.primovanta.com/cart/43588632543297:1', '_blank', 'noopener,noreferrer');
  };
  return <section id="compra" className="py-32 bg-white relative overflow-hidden" data-id="element-32">
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-33">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-stone-900 rounded-full blur-3xl" data-id="element-34"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-stone-900 rounded-full blur-3xl" data-id="element-35"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-36">
        <h2 className="text-5xl md:text-7xl font-serif mb-8 leading-tight" data-id="element-37">
          ¿Lista para destacar?
        </h2>
        <p className="text-xl text-gray-600 mb-12 max-w-xl mx-auto" data-id="element-38">
          No dejes que tu outfit pase desapercibido. Añade el toque final que
          define tu estilo.
        </p>

        <div className="inline-flex flex-col items-center mb-10" data-id="element-39">
          <span className="inline-flex items-center gap-1.5 bg-red-600 text-white text-xs font-bold tracking-[0.15em] uppercase px-4 py-1.5 rounded-full mb-5" data-id="element-40">
            <Tag className="w-3 h-3" data-id="element-41" />
            Oferta de Temporada — 36% de Descuento
          </span>

          <div className="flex items-center gap-5 mb-3" data-id="element-42">
            <span className="text-2xl text-stone-400 line-through font-light" data-id="element-43">
              $49.95 USD
            </span>
            <span className="text-6xl md:text-7xl font-serif font-bold text-stone-900 leading-none" data-id="element-44">
              $31.95
              <span className="text-2xl font-sans font-normal ml-1 text-stone-600" data-id="element-45">
                USD
              </span>
            </span>
          </div>

          <p className="text-sm font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 px-4 py-1.5 rounded-full" data-id="element-46">
            ✓ Ahorras $18.00 USD en tu pedido
          </p>

          <p className="flex items-center gap-1.5 text-xs text-stone-400 mt-3 tracking-wide" data-id="element-47">
            <Clock className="w-3 h-3" data-id="element-48" />
            Precio válido por tiempo limitado
          </p>
        </div>

        <div className="block" data-id="element-49">
          <Button size="lg" withArrow className="text-lg px-12 py-8" onClick={handleBuyClick} data-id="element-50">
            Quiero elevar mi estilo hoy
          </Button>
        </div>

        <p className="mt-6 text-sm text-gray-400" data-id="element-51">
          🔒 Envío seguro a todo México
        </p>
      </div>
    </section>;
}